
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';


export interface UserDetails {
    userId: string;
    name: string;
    fatherName: string;
    fatherOccupation: string;
    motherName: string;
    motherOccupation: string;
  }

  interface TokenResponse {
    token: string;
    
  }

@Injectable()
export class userDetailsService {

  constructor(private http: HttpClient) {}  


  // insert User Details
  public insertUserDetails(user: any): Observable<any> {
    console.log("user",user)
    const base = this.http.post('/users/userdetails', user);
    const request = base.pipe(
      map((data: TokenResponse) => {
        return data;
      })
    );
    return request;
  }

   // get User Details
   public getUserDetails(userId: string, includeImage: boolean): Observable<any> {
    const Id = userId
    const base = this.http.get(
      `/users/userdetails?userId=${Id}&includeImage=${includeImage}`
    );
    const request = base.pipe(
      map((data: TokenResponse) => {
        return data;
      })
    );
    return request;
  }

  // update image
  public updateImage(user: any): Observable<any> {
    console.log("user",user)
    const base = this.http.put('/users/userdetails', user);
    const request = base.pipe(
      map((data: TokenResponse) => {
        return data;
      })
    );
    return request;
  }

    // update image
    public updateSectionImages(user: any): Observable<any> {
      console.log("user",user)
      const base = this.http.put('/users/userdetails/updateSectionImages', user);
      const request = base.pipe(
        map((data: TokenResponse) => {
          return data;
        })
      );
      return request;
    }

 

}